import {SET_ACTIVE_MENU_ITEM} from '../constants/types'

export function setActiveMenuItem(item) {
    return {
        type: SET_ACTIVE_MENU_ITEM,
        item
    };
}